'use strict'

// requires jQuery on page
export default function () {
  $('#search-button').on('click', function (e) {
    e.preventDefault()
    $('.main-navigation__search .searchcomponent__searchinput').focus()
    toggleSearchOpenClose()
    $('body').on('click', closemastheadsearch)
  })
}

function toggleSearchOpenClose () {
  $('#search-button').toggleClass('expanded')
  $('.main-navigation__search form').toggleClass('expanded')
  $('.main-navigation__search .searchcomponent__searchinput').toggleClass('expanded')
  $('.main-navigation').toggleClass('main-navigation--searchopen')
}

// set up close event (this close handler destroys itself once used)
function closemastheadsearch (ev) {
  if (!$('.searchcomponent').has(ev.target).length) {
    toggleSearchOpenClose()
    $('body').off('click', closemastheadsearch)
  }
}
